/** @format */

export interface IHeaderSearch {
  organizationalUnit?: {
    id: string;
    name: string;
    pathNames: string[];
  };
  perimeter?: boolean;
  reference?: string;
}

export function buildHeaderSearchFilter(data: IHeaderSearch): any {
  const filter: any = {};
  if (data) {
    if (data.perimeter) {
      filter.perimeter = true;
    } else if (data.reference) {
      filter.reference = data.reference;
    } else if (data.organizationalUnit) {
      filter.organizationalUnitId = data.organizationalUnit.id;
    }
  }
  return filter;
}
